import React from "react"
import HeadlineWithFocus from "../components/HeadlineWithFocus"

export default props => (
  <div className="c-content-box">

    <h2>Hi... from James</h2>

    <HeadlineWithFocus
      modifierClassNames={`
        c-headline-focus 
        c-headline-focus--super-big 
      `}
    >
      I'm an application developer
    </HeadlineWithFocus>

    <h2
      className={`
        js-action-button-anchor
        c-content-box__subheadline 
        c-content-box__subheadline--with-button
      `}
    >
      for Web apps
      <br />
      on cloud platforms
    </h2>

  </div>
)



// WEBPACK FOOTER //
// ./src/pages/index.jsx